const Style = {
    stack: 'space-y-6',
    title: 'text-xl font-semibold text-text-primary',
    description: 'mt-1 text-sm text-text-secondary',
};

export default Style;
